'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

var _lodash = require('lodash');

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VoucherDetailById = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    detail: state.voucher.detail,
    codeToSubmit: state.voucher.codeToSubmit,
    code: state.voucher.code,
    toggleJoin: state.voucher.toggleJoin,
    joinCouponData: state.voucher.joinCouponData,
    joinCouponError: state.voucher.joinCouponError,
    promotionsEnterprise: state.voucher.promotionsEnterprise
  };
}, (0, _extends3.default)({}, voucherActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(VoucherDetailById, _Component);

  function VoucherDetailById() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VoucherDetailById);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VoucherDetailById.__proto__ || (0, _getPrototypeOf2.default)(VoucherDetailById)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: true
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VoucherDetailById, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(nextProps.detail, this.props.detail)) {
        this.setState({ loading: false });
        this.props.history.replace('/uu-dai/' + nextProps.detail.handle);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var params = this.props.params;

      this.props.getVoucherById(params.voucherId);
    }
  }, {
    key: 'render',
    value: function render() {
      var loading = this.state.loading;

      return _react2.default.createElement(
        'div',
        null,
        loading && _react2.default.createElement(_components.Loading, null)
      );
    }
  }]);
  return VoucherDetailById;
}(_react.Component), _class2.propTypes = {
  history: _react.PropTypes.object,
  detail: _react.PropTypes.object,
  params: _react.PropTypes.object,
  getVoucherById: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = VoucherDetailById;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Voucher/VoucherDetailById.js
// module id = 1642
// module chunks = 0